import { useAuth } from '@/features/users';
import { AuthRequired } from '@/shared/components/AuthRequired';
import React from 'react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated === null) {
    return null; // Wait for auth check
  }

  if (!isAuthenticated) {
    return <AuthRequired />;
  }

  return <>{children}</>;
};
